import React from 'react';
import MapView from '@arcgis/core/views/MapView';
import { MapPlacement, MapPlugin } from '../arcgis-types';
import LayerPickerWidget from './widgets/layer-picker-widget';

export const LAYER_PICKER_COMPONENT_INDEX = 10;
export const LAYER_PICKER_COMPONENT_NAME_PREFIX = 'layer-picker-';

// The LayerPickerPlugin places a widget on the map which opens the LayerPicker (`src/layer-picker/index.tsx)`.
export default function LayerPickerPlugin(uniqueId: string, editing: boolean = false): MapPlugin {
  return {
    component: {
      element: (view) => <LayerPickerWidget editing={editing} id={uniqueId} view={view} />,
      key: `${LAYER_PICKER_COMPONENT_NAME_PREFIX}${uniqueId}`,
    },
    initMap: (view: MapView) => {
      view.ui.add(`${LAYER_PICKER_COMPONENT_NAME_PREFIX}${uniqueId}`, MapPlacement.TopLeft);
    },
    extendMap: (view: MapView) => {
      const component = view.ui.find(`${LAYER_PICKER_COMPONENT_NAME_PREFIX}${uniqueId}`);
      view.ui.move({ component, position: MapPlacement.TopLeft, index: LAYER_PICKER_COMPONENT_INDEX });
    },
  };
}
